<script lang="ts">
import { storeToRefs } from "pinia"
import { useEpciCommuneStore } from "../../store"

export default {
    name: "DossierForm",
    components: { },
    props: {
        data: { type: Object, required: true },
        translationName: { type: String, required: true },
        isForm: { type: Boolean, default: false },
        validation: { type: Object, required: false },
        validationRules: { type: Object, required: false },
    },
    emits: ["updateData"],
    setup() {
        const communeStore = useEpciCommuneStore()
        const { currentEpciCommune } = storeToRefs(communeStore)

        return {
            currentEpciCommune,
        }
    },
}
</script>

<template>
    <v-row no-gutters>
        <v-col cols="12">
            <FormSection title="Localisation" with-borders-color="warning">
                <v-row>
                    <v-col cols="6">
                        <FormOfflineAutoCompleteField
                            :is-form
                            data-key="archive_room.v"
                            edit-key="v"
                            :mission="currentEpciCommune?.mission"
                            :is-clearable="true"
                            :validation="validation?.data.archive_room.id"
                            validation-key="archive_room.id"
                            :validation-rules
                            :data
                            :translation-name
                            @update-data="$emit('updateData', { [`archive_room`]: $event })"
                        />
                    </v-col>
                    <v-col cols="6">
                        <FormOfflineAutoCompleteField
                            :is-form
                            data-key="box.v"
                            edit-key="v"
                            :is-clearable="true"
                            :validation="validation?.data.box.id"
                            validation-key="box.id"
                            :mission="currentEpciCommune?.mission"
                            :archive-room="data.archive_room"
                            :validation-rules
                            :data
                            :translation-name
                            @update-data="$emit('updateData', { [`box`]: $event })"
                        />
                    </v-col>
                </v-row>
            </FormSection>
        </v-col>
    </v-row>
</template>
